export default {
    namespaced: true,
    state: {
        show: {
            spoilers: false,
            found: false,
            traps: false,
            prices: false,
            search: false,
        },
        dark: true,
    },
    getters: {
        showSpoilers: (state) => {
            return state.show.spoilers;
        },
        showFound: (state) => {
            return state.show.found;
        },
        showTraps: (state) => {
            return state.show.traps;
        },
        showPrices: (state) => {
            return state.show.prices;
        },
        showSearch: (state) => {
            return state.show.search;
        },

        darkMode: (state) => {
            return state.dark;
        },
    },
    mutations: {
        setSpoilers: (state, value) => {
            state.show.spoilers = value;
        },
        setFound: (state, value) => {
            state.show.found = value;
        },
        setTraps: (state, value) => {
            state.show.traps = value;
        },
        setPrices: (state, value) => {
            state.show.prices = value;
        },
        setSearch: (state, value) => {
            state.show.search = value;
        },

        reset: (state) => {
            state.show.spoilers = false;
            state.show.found = false;
            state.show.traps = false;
            state.show.prices = false;
            state.show.search = false;
        },

        setDarkMode: (state, value) => {
            state.dark = value;
        },
    },
    actions: {
        reset: (context) => {
            return context.commit('reset');
        },
    },
}